module.exports = __webpack_public_path__ + "static/media/Rebecca Louviere Headshot.5899993d.jpeg";